/**
 * SearchBox: the dashboard's one search field.
 * ───────────────────────────────────────────────────────────────────────────
 * A leading icon, our own clear button, and Escape to clear. First built for a
 * brand's Product Management page and shared from there, so every list that
 * needs a search gets the same control instead of its own copy.
 *
 * Controlled: the page owns the text and decides what it matches. `className`
 * is for the page's layout of the box (width, order in a toolbar); the look
 * itself is in SearchBox.css.
 */
import React from "react";
import { MdClose, MdSearch } from "react-icons/md";
import "./SearchBox.css";

const SearchBox = ({
  value,
  onChange,
  placeholder = "Search",
  ariaLabel,
  className = "",
}) => (
  <div className={`lsk-search-wrap${className ? ` ${className}` : ""}`}>
    <span className="lsk-search-icon" aria-hidden="true">
      <MdSearch size={20} />
    </span>
    <input
      className="lsk-search"
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Escape") onChange("");
      }}
      placeholder={placeholder}
      aria-label={ariaLabel || placeholder}
    />
    {value && (
      <button
        type="button"
        className="lsk-search-clear"
        onClick={() => onChange("")}
        aria-label="Clear search"
        title="Clear search"
      >
        <MdClose size={16} />
      </button>
    )}
  </div>
);

/** "2 of 3 brands" beside the box while a search is on. */
export const SearchHits = ({ shown, total, noun = "match" }) => (
  <span className="lsk-search-hits" aria-live="polite">
    {shown} of {total} {noun}
  </span>
);

export default SearchBox;
